export default __webpack_public_path__ + "static/media/arrow_right_bold.ef44e947.svg";